<template>
  <IntegrationsHelpDialog image item="integrationKanbanDialog">
    <template #image>
      <VImg :src="require('@/assets/img/integration1.png')" />
    </template>
    <template #title>
      {{ $t('title') }}
    </template>
    <template #text>
      <template v-if="$vuetify.breakpoint.mobileBreakpoint">
        {{ $t('textMobile') }}
      </template>
      <template v-else>
        {{ $t('text') }}
      </template>
    </template>
    <template #add-text>
      <i18n path="text2" for="settings">
        <router-link
          :to="{
            name: 'vacancy',
            vacancyId: $route.params.vacancyId,
          }"
        >
          {{ $t('settings') }}
        </router-link>
      </i18n>
    </template>
  </IntegrationsHelpDialog>
</template>

<script>
import IntegrationsHelpDialog from '@/components/Integrations/IntegrationsHelpDialog';

export default {
  name: 'IntegrationsHelpDialogKanban',
  components: { IntegrationsHelpDialog },
  setup() {

  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
  title: Кандидаты с rabota.ru уже импортируются
  text: 'Чтобы отправить приглашение на видеоинтервью, необходимо перетянуть карточку кандидата в столбец
  "Приглашение отправлено" или выбрать статус “приглашение отправлено” в карточке кандидата.'
  textMobile: 'Чтобы отправить приглашение на видеоинтервью, необходимо выбрать статус “приглашение отправлено” в карточке кандидата'
  text2: 'Если вы хотите, чтобы приглашения на видеоинтервью отправлялись кандидатам автоматически сразу после импорта с Работа.ру, вы можете изменить это в {0}'
  settings: настройках
</i18n>
